import React, { useContext } from 'react';
import LocaleContext from '../../../constants/localization';

const UserForm = ({
  username,
  setUsername,
  name,
  setName,
  description,
  setDescription,
  email,
  setEmail,
  password,
  setPassword,
  passwordVisible,
  setPasswordVisible,
  handleNewUser,
}) => {
  const LS = useContext(LocaleContext);

  return (
    <form onSubmit={handleNewUser} >
      <div style={{ marginBottom: '20px' }}>
        <label htmlFor="new-user-username">{LS.manageUsers.username}</label>
        <input
          name="new-user-username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          type="text"
          required
        />
        <label htmlFor="new-user-name">{LS.manageUsers.name}</label>
        <input
          name="new-user-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          type="text"
        />
        <label htmlFor="new-user-description">{LS.manageUsers.description}</label>
        <input
          name="new-user-description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          type="text"
        />
        <label htmlFor="new-user-password">{LS.manageUsers.password}</label>
        <input
          name="new-user-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type={passwordVisible ? 'text' : 'password'}
          required
        />
        <div>
          <a onClick={() => setPasswordVisible(!passwordVisible)}>
            {passwordVisible ? 'Piilota salasana' : 'Näytä salasana'}
          </a>
        </div>
      </div>
      <button className="button" type="submit">
        {LS.manageUsers.addUser}
      </button>
    </form>
  );
};

export default UserForm;
